/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* eslint-disable */
import type { CreateP2POrderSchema } from '../models/CreateP2POrderSchema';
import type { ExecuteP2POrderSchema } from '../models/ExecuteP2POrderSchema';
import type { GetP2POrderResponse } from '../models/GetP2POrderResponse';
import type { GetP2POrdersListResponse } from '../models/GetP2POrdersListResponse';
import type { P2POrderSide } from '../models/P2POrderSide';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WidgetsP2PApiService {
  /**
   * Get P2P Orders List
   * Get P2P orders list
   * @param limit Limit of items per page
   * @param offset Offset of items
   * @param side Order side (BUY/SELL)
   * @returns GetP2POrdersListResponse Successful Response
   * @throws ApiError
   */
  public static getP2POrdersListApiV2WidgetP2POrdersGet(
    limit: number = 20,
    offset?: number,
    side?: P2POrderSide | null
  ): CancelablePromise<GetP2POrdersListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v2/widget/p2p/orders',
      query: {
        limit: limit,
        offset: offset,
        side: side,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create P2P Order
   * Create P2P order
   * @param requestBody
   * @returns GetP2POrderResponse Successful Response
   * @throws ApiError
   */
  public static createP2POrderApiV2WidgetP2POrdersPost(
    requestBody: CreateP2POrderSchema
  ): CancelablePromise<GetP2POrderResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v2/widget/p2p/orders',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get P2P Order
   * Get P2P order by ID
   * @param orderId Order ID
   * @returns GetP2POrderResponse Successful Response
   * @throws ApiError
   */
  public static getP2POrderApiV2WidgetP2POrdersOrderIdGet(orderId: string): CancelablePromise<GetP2POrderResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v2/widget/p2p/orders/{order_id}',
      path: {
        order_id: orderId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Execute P2P Order
   * Execute P2P order by ID
   * @param orderId Order ID
   * @param requestBody
   * @returns GetP2POrderResponse Successful Response
   * @throws ApiError
   */
  public static executeP2POrderApiV2WidgetP2POrdersOrderIdExecutePost(
    orderId: string,
    requestBody: ExecuteP2POrderSchema
  ): CancelablePromise<GetP2POrderResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v2/widget/p2p/orders/{order_id}/execute',
      path: {
        order_id: orderId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Cancel P2P Order
   * Cancel P2P order by ID
   * @param orderId Order ID
   * @returns GetP2POrderResponse Successful Response
   * @throws ApiError
   */
  public static cancelP2POrderApiV2WidgetP2POrdersOrderIdCancelPost(
    orderId: string
  ): CancelablePromise<GetP2POrderResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v2/widget/p2p/orders/{order_id}/cancel',
      path: {
        order_id: orderId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
